import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DynamicFormComponent } from '../../core';
import { Question } from '../question';
import { QuestionsService } from '../questions.service';
import { QuestionsQuestionsService } from '../questions-questions.service';

@Component({
  selector: 'lms-question-editor',
  templateUrl: './question-editor.component.html',
  styleUrls: ['./question-editor.component.scss']
})
export class QuestionEditorComponent implements OnInit {
  @Input() question: Question;
  @Input() documentId: string;
  @Input() clientId: string;
  @Output() onSave = new EventEmitter<Question>();
  @ViewChild(DynamicFormComponent, { static: true }) public dynamicForm: DynamicFormComponent;
  public questions: any[];

  constructor(public questionsService: QuestionsService, public questionsQuestions: QuestionsQuestionsService) {}

  ngOnInit() {
    this.questions = this.questionsQuestions.getQuestions(
      this.question,
      this.documentId || this.question.documentId,
      this.clientId || this.question.clientId
    );
  }

  get submitDisabled() {
    return !this.dynamicForm.form.valid;
  }

  getQuestionDataFromForm() {
    const formData = this.dynamicForm.form.value;
    let questionData = new Question();
    questionData = Object.assign({}, formData);
    return questionData;
  }

  submit() {
    const questionData = this.getQuestionDataFromForm();
    if (this.question) {
      this.onUpdate(questionData);
    } else {
      this.onCreate(questionData);
    }
  }

  buildAnswersArray(questionData: any) {
    let answers = [];
    let position;

    Object.keys(questionData).map((objectKey) => {
      position = objectKey.match(/\d+/g);
      if (objectKey.indexOf('answer') > -1) {
        answers[position - 1] = Object.assign({}, { title: questionData[objectKey] }, answers[position - 1]);
      }
      if (objectKey.indexOf('isCorrect') > -1) {
        answers[position - 1] = Object.assign({}, { isCorrect: questionData[objectKey] }, answers[position - 1]);
      }
    });

    answers = answers.filter((item, idx) => !((item.title === null || item.title === '') && item.isCorrect === null));

    // TODO: the 4th answers could be selected as true without the text being properly set. This should be fixed in the form
    if (answers[3] && answers[3].isCorrect && !answers[3].title) {
      throw new Error('Please insert the text of the correct answer');
    }
    return answers;
  }

  onChange(event: any) {
    Object.entries(this.dynamicForm.form.controls).map((entry) => {
      if (
        entry[0].indexOf('isCorrect') > -1 &&
        event.target.id.indexOf('isCorrect') > -1 &&
        event.target.id !== entry[0]
      ) {
        entry[1].setValue(null);
      }
    });
  }

  onCreate(questionData: Object) {
    let data;
    try {
      data = Object.assign({}, questionData, { answers: this.buildAnswersArray(questionData) });
    } catch (err) {
      this.endSubmit(err);
      return;
    }

    this.questionsService
      .create(data)
      .then((question) => {
        this.onSave.emit(question);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: Object) {
    const updatedquestion: Question = Object.assign({}, this.question, updatedData);
    updatedquestion.answers = this.buildAnswersArray(updatedquestion);
    this.questionsService
      .update(updatedquestion)
      .then((question) => {
        this.onSave.emit(updatedquestion);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }

  addAnswer() {
    const answers = (this.question && this.question.answers) || [];
    const questions = this.questionsQuestions.getQuestions(this.question, this.documentId, this.clientId);

    answers.push({ title: '' });
    if (this.question) {
      this.question.answers = answers;
    }
    this.questions = questions;
  }
}
